import React from 'react';
import {useStyles} from './helper';
import clsx from 'clsx';

const ProviderItem = ({item}) => {
    const {provider, sum, sum_win, count} = item
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.provider}>{provider}</span>
            <div className={classes.wrapBlock}>
                <span className={classes.helper}>RTP</span>
                <span className={classes.description}>
                    {new Intl.NumberFormat('ru-RU').format((sum_win/sum*100).toFixed())}%
                </span>
            </div>
            <div className={classes.wrap}>
                <div className={classes.w50}>
                    <div className={clsx(classes.wrapBlock, classes.mb)}>
                        <span className={classes.helper}>Сумма ставок:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(sum ? sum.toFixed(2) : 0)} 
                        </span>
                    </div>
                    <div className={clsx(classes.wrapBlock, classes.mb)}>
                        <span className={classes.helper}>Колличество ставок:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(+count ? count : 0)} 
                        </span>
                    </div>
                </div>
                <div className={classes.w50}>
                    <div className={clsx(classes.wrapBlock, classes.mb)}>
                        <span className={classes.helper}>Сумма выигрышей:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(sum_win ? sum_win.toFixed(2) : 0)} 
                        </span>
                    </div>
                    <div className={clsx(classes.wrapBlock, classes.mb)}>
                        <span className={classes.helper}>Разница:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format((sum - sum_win).toFixed(2))} 
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProviderItem;